import { render, staticRenderFns } from "./BeStarRating.vue?vue&type=template&id=3b7371cf&scoped=true"
import script from "./BeStarRating.vue?vue&type=script&lang=js"
export * from "./BeStarRating.vue?vue&type=script&lang=js"
import style0 from "./BeStarRating.vue?vue&type=style&index=0&id=3b7371cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7371cf",
  null
  
)

export default component.exports